import { fetchFeed } from '../feedActionsCreator/general';
import { fetch } from '../../api';

export async function fetchMembers(searchText: String, { filter = 'searchKey', groupCode, pageSize = 30 }) {
  const query = {
    searchText,
    showHUMembers: true,
    excludeTotal: true,
    filter,
    groupCode,
    pageSize,
  };
  const { payload } = await fetch('members', { query });

  return { data: { users: payload.members } };
}

export function customFetch(searchText: String, query: Object) {
  return () => fetchMembers(searchText, query);
}

export function searchMembers(id: String, searchText: String, query: Object) {
  const feed = { id, dataType: 'users', filter: searchText };

  return fetchFeed(feed, true, customFetch(searchText, query));
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/searchActionsCreator/searchMembersActionsCreator.js